const Dai = () => {
	return (
		<svg xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 32 32' fill='none'>
			<path
				d='M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z'
				fill='#F4B731'
			/>
			<path
				d='M16 0.5C24.5604 0.5 31.5 7.43959 31.5 16C31.5 24.5604 24.5604 31.5 16 31.5C7.43959 31.5 0.5 24.5604 0.5 16C0.5 7.43959 7.43959 0.5 16 0.5Z'
				stroke='white'
				strokeOpacity='0.2'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M9.277 8H15.829C19.814 8 22.835 10.116 23.959 13.194H26V15.055H24.389C24.42 15.349 24.436 15.649 24.436 15.953V15.999C24.436 16.341 24.416 16.679 24.376 17.009H26V18.869H23.92C22.767 21.905 19.77 24 15.83 24H9.277V18.869H7V17.009H9.277V15.055H7V13.195H9.277V8ZM11.108 18.869V22.331H15.828C18.742 22.331 20.906 20.944 21.913 18.869H11.108ZM22.474 17.009H11.108V15.055H22.478C22.519 15.362 22.541 15.677 22.541 15.999V16.044C22.541 16.373 22.518 16.694 22.474 17.008V17.009ZM15.83 9.665C18.756 9.665 20.927 11.089 21.928 13.193H11.108V9.666H15.828L15.83 9.665Z'
				fill='white'
			/>
		</svg>
	);
};

export default Dai;
